import { Outlet, useLocation } from 'react-router';

import EnvBanner from 'app/common/components/EnvBanner';
import { SidebarWithContext } from 'app/common/components/SidebarWithContext';
import IS_IFRAME from 'app/common/data/iframe';
import { useRealtimeUpdates } from 'app/common/hooks/useRealtimeUpdates';
import { IS_BELOW_TABLET, useDeviceType } from 'app/hooks';
import { CONVERSATIONS_MESSAGING_PATH } from 'app/routing/routeIds';

import { OffsetContainer, OutletContainer, PageScrollWrapper } from './Layout.styled';

export const PAGE_CONTENT_ID = 'page-content';
export const LAYOUT_SCROLL_ID = 'layout-scroll-wrapper';

export const Layout = () => {
    const { isBelowProvidedDevices } = useDeviceType(IS_BELOW_TABLET);
    const { pathname } = useLocation();
    const isMessagingPage = pathname.startsWith(CONVERSATIONS_MESSAGING_PATH);
    useRealtimeUpdates();

    const content = (
        <OffsetContainer isBelowTablet={isBelowProvidedDevices} isMessagingPage={isMessagingPage}>
            <EnvBanner />
            <OutletContainer isMessagingPage={isMessagingPage} id={PAGE_CONTENT_ID}>
                <Outlet />
            </OutletContainer>
        </OffsetContainer>
    );

    return (
        <>
            {!IS_IFRAME && <SidebarWithContext />}
            {/* PageScrollWrapper is used to prevent layout shifts caused by the appearance or disappearance of scrollbars */}
            {isMessagingPage ? (
                content
            ) : (
                <PageScrollWrapper id={LAYOUT_SCROLL_ID}>{content}</PageScrollWrapper>
            )}
        </>
    );
};
